import { Box, BoxProps, styled } from '@mui/material';
import useSessionContext from '../LiveContext/SessionContextProvider/useSessionContext';

const InnerPageContentLayout = styled((props: BoxProps & { fullWidth: boolean, inDialog?: boolean }) => {
  const { fullWidth, inDialog, ...rest } = props;
  return <Box {...rest} />;
})(({ fullWidth, inDialog }) => ({
  flexGrow: 1,
  margin: fullWidth ? '8px 12px' : '8px 0px 8px 12px',
  padding: '8px 12px',
  paddingBottom: !inDialog ? '84px!important' : '8px',
  borderRadius: 6,
  backgroundColor: 'white',
  flexDirection: 'column',
  display: 'flex',
  overflow: 'auto',

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'white',
    borderRadius: 6,
  },
}));

export default function PageContentLayout(props: BoxProps & { inDialog?: boolean }) {
  const { inDialog } = props;
  const { session } = useSessionContext();

  return <InnerPageContentLayout {...props} fullWidth={!session} inDialog={inDialog} />;
}
